import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * 🔹 VIEW (lo que recibes del backend)
 */
export interface Siniestro {
  nivelSeveridadData: any;
  tipoSiniestroData: any;
  id?: number; // opcional en creación

  consecutivo: string;
  fecha_siniestro: string;
  hora_siniestro: string;
  fecha_reporte: string;
  hora_reporte: string;
  tipo_siniestro: number;
  nivel_severidad: number;
  lesionados: number;
  fatalidad: number;
  numero_victimas: number;
  descripcion_ocurrido: string;
  pais: string;
  departamento: number;
  municipio: number;
  direccion_referencia: string;
  coordenadas_latitud: string;
  coordenadas_longitud: string;
  ruta_trayecto: string;
  via: number;
  condiciones_climaticas: number;
  placa: string;
  tipo_vehiculo: number;
  marca: string;
  linea: string;
  modelo: number;
  propiedad_vehiculo: number;

  estado?: number; // opcional en creación
  fechaCreacion?: string; // lo devuelve el backend
  fechaModificacion?: string | null; // lo devuelve el backend
}

@Injectable({
  providedIn: "root",
})
export class SiniestrosService {
  private apiUrl = `${environment.apiUrl}/api/siniestro`;

  constructor(private http: HttpClient) {}
  
  getSiniestros(): Observable<Siniestro[]> {
    return this.http
      .get<Siniestro[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getSiniestrosActivos(): Observable<Siniestro[]> {
    return this.http
      .get<Siniestro[]>(`${this.apiUrl}/activos`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getSiniestroById(id: string | number): Observable<Siniestro> {
    return this.http
      .get<Siniestro>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

 getSiniestroByPlaca(placa: string | number): Observable<Siniestro[]> {
  return this.http
    .get<Siniestro[]>(`${this.apiUrl}/placa/${placa}`, { withCredentials: true })
    .pipe(catchError((error) => throwError(() => error)));
}

  createSiniestro(payload: Siniestro): Observable<Siniestro> {
    return this.http
      .post<Siniestro>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  updateSiniestro(id: string | number, payload: Siniestro): Observable<Siniestro> {
    return this.http
      .put<Siniestro>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  deleteSiniestro(id: string | number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  activar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  inactivar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getNextSiniestroId (){
    return this.http
      .get<any>(`${this.apiUrl}/next-id`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getConductoresSiniestrosByCedula(cedula: string | number): Observable<Siniestro[]> {
    return this.http
      .get<Siniestro[]>(`${environment.apiUrl}/api/conductores-siniestros-viales/cedula/${cedula}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  
}